import { useState } from 'react'
import { InfiniteHeroVariant } from '../types/infiniteLanding.types'

import RenderHTML from '../../../components/ui-components/RenderHTML'
import { INFINITE_FAQ_ITEMS } from '../utils/infiniteLandingFaqData'

type InfiniteLandingFaqAccordionProps = {
  heroVariant?: InfiniteHeroVariant
}

export const InfiniteLandingFaqAccordion = ({ heroVariant }: InfiniteLandingFaqAccordionProps) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [isExpanded, setIsExpanded] = useState(false)
  const visibleItems = isExpanded ? INFINITE_FAQ_ITEMS : INFINITE_FAQ_ITEMS.slice(0, 5)

  return (
    <section className='bg-black px-6 pb-32 pt-14 text-white'>
      <h2 className='text-center font-libre-caslon text-[28px] leading-[1.2] tracking-[-0.56px] text-white'>Frequently Asked Questions</h2>
      <p className='mx-auto mt-3 max-w-[320px] text-center font-libre-franklin text-[14px] text-[#9EA7B3]'>
        Everything you should know about Infinite.
      </p>
      <div className='mx-auto mt-8 max-w-[760px] divide-y divide-[#1C2835] rounded-[16px] border border-[#1C2835] bg-[#06090D]'>
        {visibleItems.map((item, index) => {
          const isOpen = activeIndex === index
          return (
            <div key={item.question} className='px-4 py-4'>
              <div
                className='flex cursor-pointer items-start justify-between gap-4'
                onClick={() => {
                  if (isOpen) {
                    setActiveIndex(-1)
                    return
                  }
                  setActiveIndex(index)
                }}
              >
                <h3 className='font-libre-franklin text-[15px] font-medium leading-[1.35] tracking-[-0.15px] text-white'>
                  {item.question}
                </h3>
                <span className='mt-[2px] min-w-[20px] text-right text-[20px] leading-none text-[#9EA7B3]'>
                  +
                </span>
              </div>
              <div className={`overflow-hidden transition-all duration-800 ease-in-out ${isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`}>
                <RenderHTML
                  innerHTMLText={item.answerHtml}
                  className='mt-3 pr-7 font-libre-franklin text-[14px] leading-[1.45] text-[#C4CEDA] [&_p]:mb-3 [&_ul]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mb-1'
                />
              </div>
            </div>
          )
        })}
        {!isExpanded && INFINITE_FAQ_ITEMS.length > 5 ? (
          <div className='px-4 py-4'>
            <div className='cursor-pointer text-center font-libre-franklin text-[14px] font-medium text-[#9EA7B3] underline' onClick={() => setIsExpanded(true)}>
              View more
            </div>
          </div>
        ) : null}
        {isExpanded && INFINITE_FAQ_ITEMS.length > 5 ? (
          <div className='px-4 py-4'>
            <div
              className='cursor-pointer text-center font-libre-franklin text-[14px] font-medium text-[#9EA7B3] underline'
              onClick={() => {
                setIsExpanded(false)
                if (activeIndex > 4) {
                  setActiveIndex(-1)
                }
              }}
            >
              View less
            </div>
          </div>
        ) : null}
      </div>
      {heroVariant === 'onboarded-open' || heroVariant === 'onboarded-club' ? (
        <p className='pb-5 pt-6 text-center text-sm font-normal text-white/70'>
          For any queries, reach us at{' '}
          <a href='mailto:infinite@powerup.money' className='underline text-white'>
            infinite@powerup.money
          </a>
        </p>
      ) : null}
    </section>
  )
}
